import { Controller } from "@hotwired/stimulus"
import LassoDataTable from "../helpers/lasso_data_table"

export default class extends Controller {
  static get targets() { return ["table"] }

  connect() {
    this.datatable = new LassoDataTable($(this.tableTarget), {
      "columns": [
        {"data": "organization_name", "className": "organization-name"},
        {"data": "external_id", "className": "external-id"},
        {"data": "name", "className": "name"},
        {"data": "image", "className": "image"},
        {"data": "date_submitted", "className": "date-submitted", "orderable": true},
        {"data": "quantity_ordered", "searchable": false, "className": "quantity-ordered"},
        {"data": "quantity_remaining", "searchable": false, "className": "quantity-Remaining"},
        {"data": "shiphero_quantity", "searchable": false, "className": "shiphero-quantity"},
        {"data": "status", "className": "status"},
      ],
      "order": [[ 4, "desc" ]],
    })
  }

  disconnect() {
    this.datatable.destroy()
  }
}
